"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPerPageFacetNames = exports.getFacetValues = exports.getFacetFilters = exports.getFacetFilter = void 0;
const types_1 = require("../types");
const getAdjustedItemCountByLimit_1 = require("./getAdjustedItemCountByLimit");
const getAlgoliaCustomData_1 = require("./getAlgoliaCustomData");
const prefixFacetName_1 = require("./prefixFacetName");
const getPerPageFacetNames = (results) => {
    if (results.disjunctiveFacets) {
        const facetValues = results.getFacetValues('dynamicAttributes', {});
        if (Array.isArray(facetValues) && facetValues?.length) {
            const orderedFacets = results.renderingContent?.facetOrdering?.facets?.order;
            const facetNames = facetValues.map(facet => (0, prefixFacetName_1.prefixFacetName)(facet.name));
            if (orderedFacets?.length) {
                return orderedFacets
                    .map(prefixFacetName_1.prefixFacetName)
                    .filter(facetFilter => facetNames.includes(facetFilter));
            }
            const customDefinedFacets = (0, getAlgoliaCustomData_1.getAlgoliaCustomData)(types_1.AlgoliaCustomDataKey.PerPageFacets, results.userData) ||
                (0, getAlgoliaCustomData_1.getAlgoliaCustomData)(types_1.AlgoliaCustomDataKey.DefaultPageFacets, results.userData);
            const perPageFacets = customDefinedFacets?.map(prefixFacetName_1.prefixFacetName);
            if (perPageFacets?.length) {
                const facets = perPageFacets.includes('attributes.*')
                    ? facetNames
                    : facetNames.filter(facetName => perPageFacets.includes(facetName));
                return facets.sort((a, b) => perPageFacets.indexOf(a) - perPageFacets.indexOf(b));
            }
        }
    }
    return [];
};
exports.getPerPageFacetNames = getPerPageFacetNames;
const getFacetValues = (facetName, facets, limit) => {
    const facetKey = (0, prefixFacetName_1.prefixFacetName)(facetName);
    if (!facets?.[facetKey]) {
        return [];
    }
    const facetValues = facets[facetKey];
    return Object.keys(facetValues).map(facetValue => ({
        name: facetValue,
        count: (0, getAdjustedItemCountByLimit_1.getAdjustedItemCountByLimit)(facetValues[facetValue], limit),
    }));
};
exports.getFacetValues = getFacetValues;
const getFacetFilter = (attribute, results, limit) => {
    if (!results) {
        return undefined;
    }
    const facetKey = (0, prefixFacetName_1.prefixFacetName)(attribute.objectID);
    const facetValues = results.getFacetValues(facetKey, {});
    const facetStats = results.getFacetStats(facetKey);
    return {
        attribute: attribute.objectID,
        name: attribute.title,
        type: attribute.type,
        values: Array.isArray(facetValues)
            ? facetValues.map(facetValue => ({
                name: facetValue.name,
                count: (0, getAdjustedItemCountByLimit_1.getAdjustedItemCountByLimit)(facetValue.count, limit),
            }))
            : [],
        facetStats,
    };
};
exports.getFacetFilter = getFacetFilter;
const getFacetFilters = (attributes, results, limit) => {
    if (!results || !attributes) {
        return undefined;
    }
    const perPageFacetNames = getPerPageFacetNames(results);
    // eslint-disable-next-line no-underscore-dangle
    const productResults = results?._rawResults;
    const facets = productResults?.at(-1)?.facets;
    const facetStats = productResults?.at(-1)?.facets_stats;
    return perPageFacetNames.reduce((facetFilters, facetName) => {
        const attribute = attributes.find(entry => (0, prefixFacetName_1.prefixFacetName)(entry.objectID) === facetName);
        if (attribute) {
            facetFilters.push({
                attribute: attribute.objectID,
                name: attribute.title,
                type: attribute.type,
                values: getFacetValues(attribute.objectID, facets, limit),
                facetStats: facetStats?.[(0, prefixFacetName_1.prefixFacetName)(attribute.objectID)],
            });
        }
        return facetFilters;
    }, []);
};
exports.getFacetFilters = getFacetFilters;
//# sourceMappingURL=getFacetFilters.js.map